import React, { memo } from 'react';
import { styled } from '@compiled/react';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { ThemedSpinner } from './ThemedSpinner.tsx';

export const ThemedLazySkeleton: React.MemoExoticComponent<() => React.JSX.Element> = memo(
	(): React.JSX.Element => (
		<Wrapper>
			<UFOLoadHold name="themed-spinner">
				<ThemedSpinner />
			</UFOLoadHold>
		</Wrapper>
	),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '100%',
	width: '100%',
});
